import { render, staticRenderFns } from "./TableHistory.vue?vue&type=template&id=aeb56c8e"
import script from "./TableHistory.vue?vue&type=script&lang=ts"
export * from "./TableHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports